// extracted by mini-css-extract-plugin
module.exports = {"Clothes":"HomePage_Clothes__3PApg","Accessories":"HomePage_Accessories__1B-Iz","Brand":"HomePage_Brand__3xblr","Price":"HomePage_Price__2-_2C"};